import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { Button, Main } from '../../components';
import useClasses from '../../hooks/useClasses';
import useRoutes from '../../hooks/useRoutes';

const PageForbidden: React.FC = () => {
  const { t } = useTranslation();
  const { login } = useRoutes();
  const { buildClass, joinClasses } = useClasses('PageForbidden');

  return (
    <Container>
      <div className="row">
        <Main className={joinClasses(buildClass(), 'col-md-8 offset-md-2 py-8 py-lg-12')}>
          <h1>{t('pages.403.title')}</h1>

          <p className="mt-3 mt-lg-5 mb-6">
            {t('pages.403.body')}
          </p>

          <Button href={login}>
            {t('buttons.login')}
          </Button>
        </Main>
      </div>
    </Container>
  );
};

export default PageForbidden;
